import Link from 'next/link';
import { useState, useRef, useEffect } from 'react';

export default function Navbar({ isMobile = false, onLinkClick }) {
  const [showPrograms, setShowPrograms] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowPrograms(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const navLinks = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about' },
    {
      name: 'Programs',
      href: '#',
      hasDropdown: true,
      subItems: [
        { name: 'All Programs', href: '/programs' },
        { name: '3-Day Immersive', href: '/programs/3-day-immersive' },
        { name: '4-Saturday Flexible', href: '/programs/4-saturday-flexible' },
        { name: 'ODC 3-Hour Workshops', href: '/programs/odc-workshops' },
      ]
    },
    { name: 'Why Choose Us', href: '/why-choose-us' },
    { name: 'Schedule', href: '/schedule' },
    { name: 'Contact Us', href: '/contact' },
  ];

  const handleLinkClick = (e, item) => {
    if (item.hasDropdown) {
      e.preventDefault();
      setShowPrograms(!showPrograms);
    } else if (isMobile && onLinkClick) {
      onLinkClick();
    }
  };

  const handleSubLinkClick = () => {
    setShowPrograms(false);
    if (isMobile && onLinkClick) {
      onLinkClick();
    }
  };

  return (
    <nav className={`${isMobile ? 'flex flex-col space-y-2' : 'flex items-center space-x-8'}`}>
      {navLinks.map((item) => (
        <div key={item.name} className="relative" ref={item.hasDropdown ? dropdownRef : null}>
          <Link
            href={item.href}
            className={`text-gray-600 hover:text-brand-primary font-medium text-sm transition-all duration-300 flex items-center ${isMobile ? 'py-3 px-4 border-b border-gray-50 last:border-0' : ''}`}
            onClick={(e) => handleLinkClick(e, item)}
          >
            {item.name}
            {item.hasDropdown && (
              <svg
                className={`ml-1 w-4 h-4 transition-transform duration-200 ${showPrograms ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            )}
          </Link>

          {item.hasDropdown && (
            <div
              className={`
                ${isMobile
                  ? (showPrograms ? 'block pl-4 bg-gray-50' : 'hidden')
                  : `absolute left-0 mt-2 w-56 bg-white border border-gray-100 shadow-xl rounded-lg py-2 z-50 transition-all duration-300 transform ${showPrograms ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible translate-y-2 pointer-events-none'}`
                }
              `}
            >
              {item.subItems.map((sub) => (
                <Link
                  key={sub.name}
                  href={sub.href}
                  className="block px-4 py-2.5 text-sm text-gray-600 hover:text-brand-primary hover:bg-gray-50 transition-colors flex items-center"
                  onClick={handleSubLinkClick}
                >
                  {sub.name}
                </Link>
              ))}
            </div>
          )}
        </div>
      ))}
    </nav>
  );
}
